import $ from "jquery";

$(function() {
  var trigger = $(".c-list__item-title");

  trigger.on("click", function() {
    if ($(window).width() >= 768) {
      return false;
    }

    var listItem = $(this).parents(".c-list__item");
    var contentWrapper = listItem.find(".c-list__item-wrapper");
    var contentHeight = contentWrapper.outerHeight() + 30;

    if (listItem.hasClass("is-expanded")) {
      listItem.css("height", contentHeight);

      setTimeout(function() {
        listItem.css("height", 80);
      }, 20);
      setTimeout(function() {
        listItem.removeClass("is-expanded");
      }, 50);
      setTimeout(function() {
        listItem.css("height", "");
      }, 100);
    } else {
      setTimeout(function() {
        listItem.css("height", contentHeight);
      }, 20);

      setTimeout(function() {
        listItem.addClass("is-expanded");
      }, 50);

      setTimeout(function() {
        listItem.css("height", "");
      }, 100);
    }
  });
});
